
// page.js (UPDATED - Dashboard + routing)
// - Now uses MatchResultForm, Leaderboard, PosterUploader
// - Keeps AddTeamForm, TeamList, NextMatchSetter
// - Removed ScoreUpdater & ScoreTableView usage

import React, { useEffect, useState } from 'react';
import axios from 'axios';
import TeamList from './TeamList';
import AddTeamForm from './AddTeamform';
import NextMatchSetter from './NextMatchSetter';

// NEW components
import MatchResultForm from './MatchResultForm';
import Leaderboard from './Leaderboard';
import PosterUploader from './PosterUploader';


import WinnerSetter from './SetWinner.jsx'


import { useNavigate } from 'react-router-dom';

// Create axios instance with base URL (used by components which import { api } from this file)
export const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: { 'Content-Type': 'application/json' },
});

// Session timeout in minutes
const SESSION_TIMEOUT = process.env.REACT_APP_TIMELOGIN || 10;

const LoginForm = ({ onLogin }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (username === process.env.REACT_APP_ADMINUSERNAME &&
        password === process.env.REACT_APP_ADMINPASSWORD) {
      onLogin();
    } else {
      setError('Invalid username or password');
    }
  };

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      backgroundColor: '#f5f5f5'
    }}>
      <div style={{
        backgroundColor: 'white',
        padding: '2rem',
        borderRadius: '8px',
        boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
        width: '100%',
        maxWidth: '400px'
      }}>
        <h2 style={{ textAlign: 'center', marginBottom: '1.5rem' }}>Admin Login</h2>
        {error && (
          <div style={{
            color: 'white',
            backgroundColor: '#ff4444',
            padding: '0.75rem',
            borderRadius: '4px',
            marginBottom: '1rem',
            textAlign: 'center'
          }}>
            {error}
          </div>
        )}
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '1rem' }}>
            <label style={{
              display: 'block',
              marginBottom: '0.5rem',
              fontWeight: '500'
            }}>
              Username
            </label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              style={{
                width: '100%',
                padding: '0.75rem',
                border: '1px solid #ddd',
                borderRadius: '4px',
                fontSize: '1rem'
              }}
              required
            />
          </div>
          <div style={{ marginBottom: '1.5rem' }}>
            <label style={{
              display: 'block',
              marginBottom: '0.5rem',
              fontWeight: '500'
            }}>
              Password
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={{
                width: '100%',
                padding: '0.75rem',
                border: '1px solid #ddd',
                borderRadius: '4px',
                fontSize: '1rem'
              }}
              required
            />
          </div>
          <button
            type="submit"
            style={{
              width: '100%',
              padding: '0.75rem',
              backgroundColor: '#0d6efd',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              fontSize: '1rem',
              cursor: 'pointer',
              transition: 'background-color 0.2s'
            }}
            onMouseOver={(e) => e.target.style.backgroundColor = '#0b5ed7'}
            onMouseOut={(e) => e.target.style.backgroundColor = '#0d6efd'}
          >
            Login
          </button>
        </form>
      </div>
    </div>
  );
};

const Dashboard = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [sessionTimer, setSessionTimer] = useState(null);
  const [teams, setTeams] = useState([]);
  const [selectedTeam, setSelectedTeam] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const navigate = useNavigate();

  // Fetch teams
  const fetchTeams = async () => {
    try {
      const response = await api.get('/teams');
      setTeams(Array.isArray(response.data) ? response.data : []);
      setError(null);
    } catch (err) {
      console.error('Error fetching teams:', err);
      setError(err.response?.data?.error || 'Failed to load teams');
    } finally {
      setLoading(false);
    }
  };

  // Refresh helper (pass to child components)
  const triggerRefresh = () => {
    setLoading(true);
    fetchTeams();
  };

  // Session handling
  const startSessionTimer = () => {
    if (sessionTimer) clearTimeout(sessionTimer);
    const expiryTime = new Date().getTime() + (SESSION_TIMEOUT * 60 * 1000);
    localStorage.setItem('sessionExpiry', expiryTime.toString());
    const timer = setTimeout(() => handleLogout(), SESSION_TIMEOUT * 60 * 1000);
    setSessionTimer(timer);
  };

  const handleLogin = () => {
    startSessionTimer();
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    localStorage.removeItem('sessionExpiry');
    if (sessionTimer) clearTimeout(sessionTimer);
    setIsAuthenticated(false);
  };

  // Check for active session
  useEffect(() => {
    const sessionExpiry = localStorage.getItem('sessionExpiry');
    if (sessionExpiry && new Date().getTime() < parseInt(sessionExpiry)) {
      setIsAuthenticated(true);
      startSessionTimer();
    } else {
      localStorage.removeItem('sessionExpiry');
    }
  }, []);

  useEffect(() => {
    if (isAuthenticated) fetchTeams();
  }, [isAuthenticated]);

  if (!isAuthenticated) return <LoginForm onLogin={handleLogin} />;

  return (
    <div style={{ padding: '2rem', maxWidth: '1200px', margin: '0 auto' }}>
      <header style={{
        marginBottom: '2rem',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      }}>
        <div>
          <h1 style={{ margin: '0 0 0.5rem' }}>Volleyball League Admin</h1>
          <p style={{ margin: 0, color: '#666' }}>Manage teams, matches and banners</p>
        </div>

        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
          <button
            onClick={() => { handleLogout(); }}
            style={{
              padding: '0.5rem 1rem',
              backgroundColor: '#dc3545',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
            onMouseOver={(e) => e.target.style.backgroundColor = '#c82333'}
            onMouseOut={(e) => e.target.style.backgroundColor = '#dc3545'}
          >
            Logout
          </button>
        </div>
      </header>

      <main style={{ display: 'grid', gap: '1.5rem' }}>
        {/* NEW: Poster uploader with preview */}
        <PosterUploader onUploaded={triggerRefresh} />

        <div style={{ display: 'grid', gap: 12 }}>
          {/* Team management */}
          <AddTeamForm onAdd={triggerRefresh} />
          <TeamList
            teams={teams}
            onSelect={setSelectedTeam}
            selectedTeam={selectedTeam}
            loading={loading}
            error={error}
          />
        </div>

        {/* Match entry & next-match setter */}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 380px', gap: 16, alignItems: 'start' }}>
          

          <div>
            {/* Keep next match setter (you had this previously) */}
            {selectedTeam ? (
              <NextMatchSetter
                team={teams.find(t => t._id === selectedTeam)?.name || selectedTeam}
                onUpdate={triggerRefresh}
              />
            ) : (
              <div style={{ padding: 12, border: '1px solid #eee', borderRadius: 6 }}>
                <p style={{ margin: 0 }}>Select a team to set its next match</p>
              </div>
            )}
          </div>
        </div>
        <div>
            {/* NEW: Match entry form (replaces ScoreUpdater) */}
            <MatchResultForm teams={teams} onMatchAdded={triggerRefresh} />

            {/* NEW: Leaderboard (shows ranking as requested) */}
            <div style={{ marginTop: 16 }}>
              <Leaderboard />
              <WinnerSetter/>
            </div>
          </div>
      </main>
    </div>
  );
};

export default Dashboard;